$(document).ready(function () {

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    }

    $(".appoinment_icon_wrapp .appoinment_contant_wrapp.without_homepage_header a").click(function () {
        setCookie("appointmentform", "appointmentform", 1)
    });
    $(".main_claculator-right-part .right-side-bottom a.btn").click(function () {
        setCookie("appointmentform", "appointmentform", 1)
    });

    $(document).on("click", ".custom-first-menu-here", function () {
        $(this).parents("li.slide-nav__item").toggleClass("active-menu")
    });

    jQuery.getJSON("/cart.js", function (cart) {
        var original_price = cart.total_price,
            total_goal = $(".sidebar_progress_bar").attr("data-goal"),
            final_result = original_price / 100
        if (final_result >= total_goal) {
            $("span.minus_val").hide();
            $(".free_shipping_text").show()
        } else if (final_result < total_goal) {
            $(".free_shipping_text").hide()
        }
    });

    $("ul.site-nav li.site-nav--has-dropdown").mouseleave(function () {
        $("body").removeClass("on_header_hover")
    });
    $("ul.site-nav li.site-nav--has-dropdown").mouseenter(function () {
        $("body").addClass("on_header_hover")
    });

    $(document).on("change", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown").addClass("placeholder_hide")
        } else {
            $(this).addClass("placeholder_shown").removeClass("placeholder_hide")
        }
    });

    $(document).on("focus", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown").addClass("placeholder_hide")
        } else {
            $(this).addClass("placeholder_shown").removeClass("placeholder_hide")
        }
    });

    var disabledDates = [
        "2024-07-29","2024-07-30","2024-07-31",
        "2024-08-01","2024-08-02","2024-08-03","2024-08-04","2024-08-05","2024-08-06",
        "2024-08-07","2024-08-08","2024-08-09","2024-08-10","2024-08-11","2024-08-12",
        "2024-08-13","2024-08-14","2024-08-15","2024-08-16","2024-08-17"
    ];

    $('#datepic_client_date, #second_datepic_client_date').datepicker({
        minDate: new Date(),
        dateFormat: "yy-mm-dd",
        beforeShowDay: function (date) {
            var dayOfWeek = date.getDay();
            var formattedDate = $.datepicker.formatDate('yy-mm-dd', date);
            var today = new Date();
            var isToday = formattedDate === $.datepicker.formatDate('yy-mm-dd', today);
            var isDisabledDate = disabledDates.indexOf(formattedDate) !== -1;
            var isWeekend = dayOfWeek === 0 || dayOfWeek === 1;
            if ((isToday && (dayOfWeek === 0 || dayOfWeek === 1)) || isDisabledDate || isWeekend) {
                return [false, "disabled"]
            } else {
                return [true, ""]
            }
        },
        onSelect: function (dateText, inst) {
            var selectedDate = new Date(dateText);
            var dayOfWeek = selectedDate.getDay();
            if (dayOfWeek === 0 || dayOfWeek === 1) {
                selectedDate.setDate(selectedDate.getDate() + (dayOfWeek === 0 ? 2 : 1));
                $(this).datepicker('setDate', selectedDate)
            }
        }
    });

    // ============================================
    // CART ADJUSTMENT EVENTS
    // ============================================
    adjustAmount(true);

    $(document).on("CartDrawer:open drawerOpen ajaxProduct:added", () => {
        adjustAmount(false);
    });

    $(document).on("cart:updated", () => {
        console.log("cart:updated");
        adjustAmount(false);
        if (!isFistTimePageLoad) {
            setTimeout(() => { window.location.reload(); }, 500);
        }
    });

    $(".adjust-value").on("keyup", function () {
        isAmountAdjusting = true;
    });

    $(".adjust-value").on("change", function () {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        isAmountAdjusting = true;

        let newVal = parseFloat($input.val().replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1"));
        let itemAmount = parseFloat($input.data("value"));
        let symbol = newVal > itemAmount ? "+" : "-";
        let remainAmount = Math.abs(itemAmount - newVal);

        $input.attr("data-adjust_symbol", symbol);
        $input.attr("data-adjust_amount", remainAmount);

        thisElement = {
            symbol: symbol,
            remainAmount: remainAmount,
            id: $input.data("id"),
            qty: $input.parents(".cart__item").find(".js-qty__num").val(),
        };

        pendingUpdates.set(itemKey, {
            key: itemKey,
            $input: $input,
            quantity: Number($input.parents(".cart__item").find(".js-qty__num").val() || 1),
            adjustAmount: remainAmount,
            adjustSymbol: symbol
        });

        adjustAmount(false);
        console.log('Price changed, waiting for blur/click outside to save...');
    });

    $(".adjust-value").on("blur", async function () {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");

        if (pendingUpdates.has(itemKey)) {
            console.log('Input blurred, updating cart...');
            isLoadingAdjuster = true;
            await updateSingleLineItem($input);
            pendingUpdates.delete(itemKey);
            isAmountAdjusting = false;
            isLoadingAdjuster = false;
            adjustAmount(false);
        }
    });

    $(document).on("click", "#myBtn", async function (e) {
        e.preventDefault();
        $(".customer_exist").removeClass('required');
        if ($(".customer_exist").length > 0 && $(".customer_exist").val() == "") {
            $(".customer_exist").addClass('required').focus();
            return;
        }
        if (pendingUpdates.size > 0) {
            await updateAllPendingLineItems();
        }
        initViriffCheckout();
    });

    $(document).on("click", "#myModalClose", function () {
        $("#myModal").hide();
    });

    $(document).on("click", async function (e) {
        if (!$(e.target).hasClass("adjust-value") && !$(e.target).closest(".adjust-value").length) {
            if (pendingUpdates.size > 0) {
                console.log('Clicked outside, updating all pending items...');
                await updateAllPendingLineItems();
            }
        }
    });

    $(document).on("focus", ".adjust-value", async function () {
        const currentKey = $(this).parents(".cart__item").data("key");
        if (pendingUpdates.size > 0) {
            const itemsToUpdate = Array.from(pendingUpdates.values()).filter(item => item.key !== currentKey);
            if (itemsToUpdate.length > 0) {
                console.log('Switching to another input, updating previous item...');
                isLoadingAdjuster = true;
                for (const itemData of itemsToUpdate) {
                    await updateSingleLineItemFromData(itemData);
                    pendingUpdates.delete(itemData.key);
                }
                isLoadingAdjuster = false;
                adjustAmount(false);
            }
        }
    });

    // ============================================
    // GOOGLE MAPS AUTOCOMPLETE
    // ============================================
    if (document.getElementById("search_input")) {
        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("search_input"), {
            types: ["geocode"],
            componentRestrictions: { country: "it" } 
        });
        google.maps.event.addListener(autocomplete, "place_changed", function () {
            var near_place = autocomplete.getPlace();
            if (document.getElementById("loc_lat"))
                document.getElementById("loc_lat").value = near_place.geometry.location.lat();
            if (document.getElementById("loc_long"))
                document.getElementById("loc_long").value = near_place.geometry.location.lng();
            if (document.getElementById("latitude_view"))
                document.getElementById("latitude_view").innerHTML = near_place.geometry.location.lat();
            if (document.getElementById("longitude_view"))
                document.getElementById("longitude_view").innerHTML = near_place.geometry.location.lng();
        });
    }

});

// ============================================
// GLOBAL VARIABLES
// ============================================
let thisElement = null;
let isAmountAdjusting = false;
let isLoadingAdjuster = false;
let isFistTimePageLoad = true;
let pendingUpdates = new Map();
let isAmountAdjust = false;

// ============================================
// HELPER: addJsScript
// ============================================
function addJsScript(src) {
    var script = document.createElement("script");
    script.src = src;
    document.head.appendChild(script);
}

// ============================================
// Update a single line item from input element
// ============================================
async function updateSingleLineItem($input) {
    const itemKey = $input.parents(".cart__item").data("key");
    const quantity = Number($input.parents(".cart__item").find(".js-qty__num").val() || 1);
    const adjustAmt = $input.attr("data-adjust_amount");
    const adjustSymbol = $input.attr("data-adjust_symbol");

    try {
        console.log('Calling /cart/change.js for item:', itemKey);
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: itemKey,
                quantity: quantity,
                properties: { _adjust_amount: adjustAmt, _adjust_symbol: adjustSymbol }
            })
        });
        const result = await response.json();
        if (result.status === 'bad_request') {
            console.error('Cart update error:', result.message);
            return null;
        }
        console.log('Item updated successfully:', result);
        return result;
    } catch (error) {
        console.error('Error updating item:', error);
        return null;
    }
}

// ============================================
// Update a single line item from stored data
// ============================================
async function updateSingleLineItemFromData(itemData) {
    try {
        console.log('Calling /cart/change.js for item:', itemData.key);
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: itemData.key,
                quantity: itemData.quantity,
                properties: { _adjust_amount: itemData.adjustAmount, _adjust_symbol: itemData.adjustSymbol }
            })
        });
        const result = await response.json();
        if (result.status === 'bad_request') {
            console.error('Cart update error:', result.message);
            return null;
        }
        console.log('Item updated successfully:', result);
        return result;
    } catch (error) {
        console.error('Error updating item:', error);
        return null;
    }
}

// ============================================
// Update all pending line items
// ============================================
async function updateAllPendingLineItems() {
    if (pendingUpdates.size === 0) return;
    isLoadingAdjuster = true;
    isAmountAdjusting = true;
    console.log('Updating', pendingUpdates.size, 'pending items...');
    for (const [key, itemData] of pendingUpdates.entries()) {
        await updateSingleLineItemFromData(itemData);
    }
    pendingUpdates.clear();
    isAmountAdjusting = false;
    thisElement = null;
    isLoadingAdjuster = false;
    adjustAmount(false);
    console.log('All pending updates completed');
}

// ============================================
// CHECKOUT FUNCTION
// ============================================
async function initViriffCheckout() {
    $("#myBtn").attr("disabled", "true").html('Attendere prego...');

    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    'Indirizzo e-mail del cliente': $("#client-email").val(),
                    'Codice Fiscale': $("#codice-fiscale").val()
                }
            })
        });

        if (pendingUpdates.size > 0) {
            await updateAllPendingLineItems();
        }

        if (isAmountAdjusting) {
            setTimeout(() => { initViriffCheckout(); }, 500);
            return false;
        }

        adjustAmount(false);

        var customerId = ShopifyAnalytics?.meta?.page?.customerId;
        var shippingVal = $(".shipping-line-item--radio input[type='radio']:checked").val();

        if (customerId && (isAmountAdjust || shippingVal == "Click and collect")) {
            $.getJSON("/cart.js", function (data) {
                $.post("https://goldunion.codevibez.com/veriff/index.php", {
                    shop: "goldunion-it.myshopify.com",
                    customer: customerId,
                    cart: data,
                    email: $("#client-email").val(),
                    shipping: {
                        name: shippingVal || "",
                        agent: $("#agency-id").length > 0 ? $("#agency-id").val() : "",
                    },
                }, (result) => {
                    if (result && result.order && result.order.invoice_url) {
                        window.location = result.order.invoice_url;
                    } else {
                        window.location = window.location.origin + "/checkout";
                    }
                }).fail(function () {
                    window.location = window.location.origin + "/checkout";
                });
            }).fail(function () {
                window.location = window.location.origin + "/checkout";
            });
        } else {
            window.location = window.location.origin + "/checkout";
        }

    } catch (err) {
        console.error('initViriffCheckout error:', err);
        window.location = window.location.origin + "/checkout";
    }
}

// ============================================
// ADJUST AMOUNT DISPLAY
// ============================================
function adjustAmount(updateValue) {
    let addedAmount = 0;
    isAmountAdjust = false;

    if ($(".adjust-value").length > 0) {
        isFistTimePageLoad = false;

        $(".adjust-value").each(function () {
            let symbol = $(this).attr("data-adjust_symbol") || "";
            let amount = parseFloat($(this).attr("data-adjust_amount")) || 0;
            let itemAmount = parseFloat($(this).attr("data-value")) || 0;
            let amt = 0;

            if (amount > 0) {
                isAmountAdjust = true;
            }

            let qty = parseInt($(this).parents(".cart__item").find(".js-qty__num").val()) || 1;

            if (symbol == "+") {
                amt += amount;
                itemAmount += amount;
            } else if (symbol == "-") {
                amt -= amount;
                itemAmount -= amount;
            }

            addedAmount += amt * qty;

            if ($(".cart__drawer-form").length > 0) {
                $(this).parents(".cart__item").find(".pricediv").html(
                    theme.Currency.formatMoney(itemAmount * 100)
                );
            }

            if (updateValue) $(this).val(itemAmount);
        });

        $("#main--shipping-div").hide();
        if (isAmountAdjust) {
            $("#main--shipping-div").show();
        }

        let cartTotalItem = $(".main__cart__item-sub--subtotal");
        let total = theme.Currency.formatMoney(
            parseInt(cartTotalItem.data("total")) + addedAmount * 100
        );

        $(".main__cart__item-sub--subtotal-adjust").remove();

        if ($(".cart__item--subtotal--adjust").length > 0) {
            $(".cart__item--subtotal--adjust").append('<div class="main__cart__item-sub--subtotal-adjust"></div>');
            $(".main__cart__item-sub--subtotal--adjust").hide();
            $(".main__cart__item-sub--subtotal-adjust").html(total);
            return;
        }

        if ($(".cart__drawer-form").length > 0) {
            $(".cart__drawer-form .main__cart__item-sub--subtotal .wholesale-cart-total span").html(total);
            return;
        }
    }
}

/* ==========================================================
   PHONE HELPERS (IT)
========================================================== */

/* Allow only digits, + space . - ( ) while typing (no length cap) */
$(document).on('input', '.custom_mobile_fileds', function () {
    this.value = this.value.replace(/[^\d+\s.\-()]/g, '');
});

function getItiInstance(input) {
    return (window.intlTelInputGlobals && intlTelInputGlobals.getInstance)
        ? intlTelInputGlobals.getInstance(input)
        : null;
}

/**
 * Normalizes and validates the phone number.
 * Returns { valid: bool, e164: '+393331234567', dial: '+39' }
 */
function validatePhoneInput($form) {

    var DEFAULT_DIAL = '+39';

    var input  = $form.find('.custom_mobile_fileds')[0];
    var result = { valid: false, e164: '', dial: '' };

    if (!input) return result;

    // Strip spaces, dots, dashes, parentheses
    var d = String(input.value || '').replace(/[\s.\-()]/g, '');

    // Only digits and an optional leading "+"
    if (!d || !/^\+?\d+$/.test(d)) return result;

    // 0039... -> +39...
    if (d.indexOf('00') === 0) d = '+' + d.slice(2);

    var iti  = getItiInstance(input);
    var dial = ($form.find('.iti__selected-dial-code').text() || '').trim();

    if (iti && iti.getSelectedCountryData && iti.getSelectedCountryData().dialCode) {
        dial = '+' + iti.getSelectedCountryData().dialCode;
    }

    if (!dial) dial = DEFAULT_DIAL;

    // France only: +33 (0)6... -> +33 6...
    if (dial === '+33' && d.indexOf('+330') === 0) d = '+33' + d.slice(4);

    /* ---- Preferred path: intl-tel-input with utils loaded ---- */
    if (iti && window.intlTelInputUtils && typeof iti.isValidNumber === 'function') {

        iti.setNumber(d);

        if (iti.isValidNumber()) {
            result.valid = true;
            result.e164  = iti.getNumber();
            result.dial  = '+' + iti.getSelectedCountryData().dialCode;
        }

        return result;
    }

    /* ---- Fallback without utils ---- */
    var national;

    if (d.charAt(0) === '+') {
        if (d.indexOf(dial) !== 0) return result;
        national = d.slice(dial.length);
    } else {
        national = d;
    }

    if (dial === '+39') {
        // Italy: mobiles start with 3 (9-10 digits), landlines start with 0 (6-11 digits).
        // The leading 0 of landlines is part of the number and must be kept.
        if (!/^(3\d{8,9}|0\d{5,10})$/.test(national)) return result;

    } else if (dial === '+33') {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^[1-9]\d{8}$/.test(national)) return result;

    } else {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^\d{6,12}$/.test(national)) return result;
    }

    result.valid = true;
    result.e164  = dial + national;
    result.dial  = dial;

    return result;
}


async function sendContactFormAction(formSelector) {

    var $form = $(formSelector);

    // Get submit button for THIS form only
    var $submitButton = $form.find('.brn-contact-form-submit');

    // Prevent duplicate submission after successful (or uncertain) booking
    if ($submitButton.attr('data-booking-submitted') === 'true') {
        return false;
    }

    // Prevent multiple clicks while request is processing
    if ($submitButton.attr('data-booking-submitting') === 'true') {
        return false;
    }


    var dateofbith = $form.find('input[name=client_date]').val();
    var meeting_time = $form.find('select[name=client_time]').val();
    var agency = $form.find('select[name=agent]').val();
    var pattern = $form.find('select[name=pattern]').val();
    var email = $.trim($form.find('input[name="email"]').val());
    var address = $.trim($form.find('input[name="address"]').val());

    var fnameField = $form.find('input[name="fname"]');
    var lnameField = $form.find('input[name="lname"]');

    var fname = $.trim(fnameField.val());
    var lname = $.trim(lnameField.val());


    // ── helpers ──────────────────────────────────────────────

    var nameRegex = /^[A-Za-zÀ-ÿ]+([ '-][A-Za-zÀ-ÿ]+)*$/;

    var emailPattern =
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    var timeInvalid =
        !meeting_time ||
        meeting_time === '' ||
        meeting_time === 'Heure' ||
        meeting_time === 'Ora' ||
        meeting_time === 'Orario';

    var agencyInvalid =
        $form.find('select[name=agent]').length > 0 &&
        !agency;

    var patternInvalid =
        $form.find('select[name=pattern]').length > 0 &&
        !pattern;


    // ── Step 1 – reset ALL errors ─────────────────────────────

    $form.find('.agency-error-message').hide();
    $form.find('.motif-error-message').hide();
    $form.find('.name-error-message').hide();
    $form.find('.lastname-error-message').hide();
    $form.find('.contact-error-message').hide();
    $form.find('.date-error-message').hide();
    $form.find('.time-error-message').hide();
    $form.find('.email-error-message').hide();
    $form.find('.address-error-message').hide();
    $form.find('.privacy-error-message').hide();   // ADDED

    $form.find('select[name=agent]')
        .removeClass('mobile-error-show');

    $form.find('select[name=pattern]')
        .removeClass('mobile-error-show');

    $form.find('.name_main-wrapp')
        .removeClass('mobile-error-show');

    $form.find('.lastname_main-wrapp')
        .removeClass('mobile-error-show');

    $form.find('.mobile_label_input')
        .removeClass('mobile-error-show');

    $form.find('.date_main-wrapp')
        .removeClass('mobile-error-show');

    $form.find('.time_main-wrapp')
        .removeClass('mobile-error-show');

    $form.find('.email_label_input')
        .removeClass('mobile-error-show');

    $form.find('.address_main-wrapp')
        .removeClass('mobile-error-show');


    // ── Step 2 – validate ALL fields ──────────────────────────

    var hasError = false;


    // Agency
    if (agencyInvalid) {

        $form.find('.agency-error-message').show();

        $form.find('select[name=agent]')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Pattern / Motif
    if (patternInvalid) {

        $form.find('.motif-error-message').show();

        $form.find('select[name=pattern]')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // First name
    if (fname === '' || !nameRegex.test(fname)) {

        $form.find('.name-error-message')
            .text('Inserisci un nome valido.')
            .show();

        $form.find('.name_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Last name
    if (lname === '' || !nameRegex.test(lname)) {

        $form.find('.lastname-error-message')
            .text('Inserisci un cognome valido.')
            .show();

        $form.find('.lastname_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Phone
    var phoneResult = validatePhoneInput($form);

    if (!phoneResult.valid) {

        $form.find('.contact-error-message')
            .text('Inserisci un numero valido (es. 333 123 4567).')
            .show();

        $form.find('.mobile_label_input')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Email
    if (email === '' || !emailPattern.test(email)) {

        $form.find('.email-error-message').show();

        $form.find('.email_label_input')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Date
    if (!dateofbith || dateofbith === '') {

        $form.find('.date-error-message').show();

        $form.find('.date_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Time
    if (timeInvalid) {

        $form.find('.time-error-message').show();

        $form.find('.time_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // Address - only if field exists in this form
    if (
        $form.find('input[name="address"]').length > 0 &&
        address === ''
    ) {

        $form.find('.address-error-message').show();

        $form.find('.address_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;
    }


    // ADDED: Privacy policy
    var $privacy = $form.find('input[name="privacy_policy"]');

    if ($privacy.length && !$privacy.is(':checked')) {

        $form.find('.privacy-error-message')
            .text("Accetta l'informativa sulla privacy per confermare il tuo appuntamento.")
            .show();

        hasError = true;
    }


    // ── Step 3 – stop if validation failed ────────────────────

    if (hasError) {
        return false;
    }


    // ── Step 4 – LOCK THIS FORM'S SUBMIT BUTTON ───────────────

    $submitButton
        .attr('data-booking-submitting', 'true')
        .attr('disabled', true)
        .html('Appuntamento confermato...');


    // ── Step 5 – API endpoint ─────────────────────────────────

    let formAction =
        'https://goldunion.codevibez.com/api/contact';


    // ── Step 6 – Form data ────────────────────────────────────

    let formEl = $form[0];

    let formData = new FormData(formEl);


    let object = {

        country_code:
            $form.find('.iti__selected-dial-code').html() || '',

        shop:
            'goldunion-it.myshopify.com'
    };


    formData.forEach(function(value, key) {
        object[key] = value;
    });

    // Send normalized E.164 number and matching dial code
    // (must stay AFTER the forEach so the raw typed value does not overwrite it)
    object.contact      = phoneResult.e164;   // e.g. +393331234567
    object.country_code = phoneResult.dial;   // e.g. +39


    let json = JSON.stringify(object);


    // ── Step 7 – Submit ───────────────────────────────────────

    var BTN_LABEL = 'Conferma il mio appuntamento';

    var UNCERTAIN_MESSAGE =
        "Lo stato dell'appuntamento è incerto. Verifica il tuo appuntamento prima di riprovare.";

    function showMessage(type, html) {
        $form.find('.note--success')
            .addClass(type)
            .removeClass(type === 'success' ? 'error' : 'success')
            .html(html)
            .show();
    }

    // Booking may or may not exist: keep button disabled, block resubmission
    function markUncertain() {
        $submitButton
            .removeAttr('data-booking-submitting')
            .attr('data-booking-submitted', 'true')
            .attr('disabled', true)
            .html(BTN_LABEL);

        showMessage('error', UNCERTAIN_MESSAGE);
    }

    // Booking definitely not created: allow another attempt
    function markFailed(message) {
        $submitButton
            .removeAttr('data-booking-submitting')
            .removeAttr('disabled')
            .html(BTN_LABEL);

        showMessage('error', message || 'Si è verificato un errore.');
    }

    let customResponse;
    let customResult;

    try {
        customResponse = await fetch(formAction, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: json
        });
    } catch (error) {
        // Network failure / timeout: request may have reached the server
        console.error('Error:', error);
        markUncertain();
        return false;
    }

    try {
        customResult = await customResponse.json();
    } catch (error) {
        // Response arrived but is not valid JSON: outcome unknown
        console.error('Error:', error);
        markUncertain();
        return false;
    }

    // HTTP-level errors
    if (!customResponse.ok) {

        // 4xx: the server rejected the request, so no booking was created
        if (customResponse.status >= 400 && customResponse.status < 500) {
            markFailed(customResult && customResult.message);
        } else {
            // 5xx: the booking may have been created before the failure
            markUncertain();
        }

        return false;
    }

    // Application-level error returned with HTTP 200
    if (customResult && customResult.status === 'error') {
        markFailed(customResult.message);
        return false;
    }


    // ── SUCCESS ───────────────────────────────────────────────

    $submitButton
        .removeAttr('data-booking-submitting')
        .attr('data-booking-submitted', 'true')
        .attr('disabled', true)
        .html(BTN_LABEL);

    showMessage(
        'success',
        'Grazie per averci contattato. Vi risponderemo il prima possibile.'
    );


    // ── GOOGLE ADS / GA4 CONVERSION ───────────────────────────
    // Tracking must never affect the booking result

    try {

        var data_handle =
            $form
                .parents('.tab_data_main')
                .attr('data-handle');

        var agency_name =
            data_handle === 'En agence'
                ? $form
                    .find('select#agency-id option:selected')
                    .val()
                : $form
                    .find('input#search_input')
                    .val();

        var data_currency =
            $('html').attr('currency');

        if (typeof gtag === 'function') {

            gtag('event', 'conversion', {

                send_to: 'G-MTHYR484J8',

                'Home or Agency':
                    data_handle,

                'Agency name (city)':
                    agency_name,

                currency:
                    data_currency
            });

        }

    } catch (trackingError) {
        console.error('Tracking error:', trackingError);
    }


    return false;
}


// function validatePhoneNumber(input_str) {
//     var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
//     return re.test(input_str);
// }

// async function sendContactFormAction(formSelector) {

//     var $form = $(formSelector);

//     // Get submit button for THIS form only
//     var $submitButton = $form.find('.brn-contact-form-submit');

//     // Prevent duplicate submission after successful (or uncertain) booking
//     if ($submitButton.attr('data-booking-submitted') === 'true') {
//         return false;
//     }

//     // Prevent multiple clicks while request is processing
//     if ($submitButton.attr('data-booking-submitting') === 'true') {
//         return false;
//     }


//     var phone = $form.find('.custom_mobile_fileds').val();
//     var dateofbith = $form.find('input[name=client_date]').val();
//     var meeting_time = $form.find('select[name=client_time]').val();
//     var agency = $form.find('select[name=agent]').val();
//     var pattern = $form.find('select[name=pattern]').val();
//     var email = $.trim($form.find('input[name="email"]').val());
//     var address = $.trim($form.find('input[name="address"]').val());

//     var fnameField = $form.find('input[name="fname"]');
//     var lnameField = $form.find('input[name="lname"]');

//     var fname = $.trim(fnameField.val());
//     var lname = $.trim(lnameField.val());


//     // ── helpers ──────────────────────────────────────────────

//     var nameRegex = /^[A-Za-zÀ-ÿ]+([ '-][A-Za-zÀ-ÿ]+)*$/;

//     var emailPattern =
//         /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

//     var timeInvalid =
//         !meeting_time ||
//         meeting_time === '' ||
//         meeting_time === 'Heure' ||
//         meeting_time === 'Ora' ||
//         meeting_time === 'Orario';

//     var agencyInvalid =
//         $form.find('select[name=agent]').length > 0 &&
//         !agency;

//     var patternInvalid =
//         $form.find('select[name=pattern]').length > 0 &&
//         !pattern;


//     // ── Step 1 – reset ALL errors ─────────────────────────────

//     $form.find('.agency-error-message').hide();
//     $form.find('.motif-error-message').hide();
//     $form.find('.name-error-message').hide();
//     $form.find('.lastname-error-message').hide();
//     $form.find('.contact-error-message').hide();
//     $form.find('.date-error-message').hide();
//     $form.find('.time-error-message').hide();
//     $form.find('.email-error-message').hide();
//     $form.find('.address-error-message').hide();

//     $form.find('select[name=agent]')
//         .removeClass('mobile-error-show');

//     $form.find('select[name=pattern]')
//         .removeClass('mobile-error-show');

//     $form.find('.name_main-wrapp')
//         .removeClass('mobile-error-show');

//     $form.find('.lastname_main-wrapp')
//         .removeClass('mobile-error-show');

//     $form.find('.mobile_label_input')
//         .removeClass('mobile-error-show');

//     $form.find('.date_main-wrapp')
//         .removeClass('mobile-error-show');

//     $form.find('.time_main-wrapp')
//         .removeClass('mobile-error-show');

//     $form.find('.email_label_input')
//         .removeClass('mobile-error-show');

//     $form.find('.address_main-wrapp')
//         .removeClass('mobile-error-show');


//     // ── Step 2 – validate ALL fields ──────────────────────────

//     var hasError = false;


//     // Agency
//     if (agencyInvalid) {

//         $form.find('.agency-error-message').show();

//         $form.find('select[name=agent]')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Pattern / Motif
//     if (patternInvalid) {

//         $form.find('.motif-error-message').show();

//         $form.find('select[name=pattern]')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // First name
//     if (fname === '' || !nameRegex.test(fname)) {

//         $form.find('.name-error-message')
//             .text('Inserisci un nome valido.')
//             .show();

//         $form.find('.name_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Last name
//     if (lname === '' || !nameRegex.test(lname)) {

//         $form.find('.lastname-error-message')
//             .text('Inserisci un cognome valido.')
//             .show();

//         $form.find('.lastname_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Phone
//     if (!validatePhoneNumber(phone)) {

//         $form.find('.contact-error-message').show();

//         $form.find('.mobile_label_input')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Email
//     if (email === '' || !emailPattern.test(email)) {

//         $form.find('.email-error-message').show();

//         $form.find('.email_label_input')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Date
//     if (!dateofbith || dateofbith === '') {

//         $form.find('.date-error-message').show();

//         $form.find('.date_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Time
//     if (timeInvalid) {

//         $form.find('.time-error-message').show();

//         $form.find('.time_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // Address - only if field exists in this form
//     if (
//         $form.find('input[name="address"]').length > 0 &&
//         address === ''
//     ) {

//         $form.find('.address-error-message').show();

//         $form.find('.address_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;
//     }


//     // ── Step 3 – stop if validation failed ────────────────────

//     if (hasError) {
//         return false;
//     }


//     // ── Step 4 – LOCK THIS FORM'S SUBMIT BUTTON ───────────────

//     $submitButton
//         .attr('data-booking-submitting', 'true')
//         .attr('disabled', true)
//         .html('Appuntamento confermato...');


//     // ── Step 5 – API endpoint ─────────────────────────────────

//     let formAction =
//         'https://goldunion.codevibez.com/api/contact';


//     // ── Step 6 – Form data ────────────────────────────────────

//     let formEl = $form[0];

//     let formData = new FormData(formEl);


//     let object = {

//         country_code:
//             $form.find('.iti__selected-dial-code').html() || '',

//         shop:
//             'goldunion-it.myshopify.com'
//     };


//     formData.forEach(function(value, key) {
//         object[key] = value;
//     });


//     let json = JSON.stringify(object);


//     // ── Step 7 – Submit ───────────────────────────────────────

//     var BTN_LABEL = 'Conferma il mio appuntamento';

//     var UNCERTAIN_MESSAGE =
//         "Lo stato dell'appuntamento è incerto. Verifica il tuo appuntamento prima di riprovare.";

//     function showMessage(type, html) {
//         $form.find('.note--success')
//             .addClass(type)
//             .removeClass(type === 'success' ? 'error' : 'success')
//             .html(html)
//             .show();
//     }

//     // Booking may or may not exist: keep button disabled, block resubmission
//     function markUncertain() {
//         $submitButton
//             .removeAttr('data-booking-submitting')
//             .attr('data-booking-submitted', 'true')
//             .attr('disabled', true)
//             .html(BTN_LABEL);

//         showMessage('error', UNCERTAIN_MESSAGE);
//     }

//     // Booking definitely not created: allow another attempt
//     function markFailed(message) {
//         $submitButton
//             .removeAttr('data-booking-submitting')
//             .removeAttr('disabled')
//             .html(BTN_LABEL);

//         showMessage('error', message || 'Si è verificato un errore.');
//     }

//     let customResponse;
//     let customResult;

//     try {
//         customResponse = await fetch(formAction, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: json
//         });
//     } catch (error) {
//         // Network failure / timeout: request may have reached the server
//         console.error('Error:', error);
//         markUncertain();
//         return false;
//     }

//     try {
//         customResult = await customResponse.json();
//     } catch (error) {
//         // Response arrived but is not valid JSON: outcome unknown
//         console.error('Error:', error);
//         markUncertain();
//         return false;
//     }

//     // HTTP-level errors
//     if (!customResponse.ok) {

//         // 4xx: the server rejected the request, so no booking was created
//         if (customResponse.status >= 400 && customResponse.status < 500) {
//             markFailed(customResult && customResult.message);
//         } else {
//             // 5xx: the booking may have been created before the failure
//             markUncertain();
//         }

//         return false;
//     }

//     // Application-level error returned with HTTP 200
//     if (customResult && customResult.status === 'error') {
//         markFailed(customResult.message);
//         return false;
//     }


//     // ── SUCCESS ───────────────────────────────────────────────

//     $submitButton
//         .removeAttr('data-booking-submitting')
//         .attr('data-booking-submitted', 'true')
//         .attr('disabled', true)
//         .html(BTN_LABEL);

//     showMessage(
//         'success',
//         'Grazie per averci contattato. Vi risponderemo il prima possibile.'
//     );


//     // ── GOOGLE ADS / GA4 CONVERSION ───────────────────────────
//     // Tracking must never affect the booking result

//     try {

//         var data_handle =
//             $form
//                 .parents('.tab_data_main')
//                 .attr('data-handle');

//         var agency_name =
//             data_handle === 'En agence'
//                 ? $form
//                     .find('select#agency-id option:selected')
//                     .val()
//                 : $form
//                     .find('input#search_input')
//                     .val();

//         var data_currency =
//             $('html').attr('currency');

//         if (typeof gtag === 'function') {

//             gtag('event', 'conversion', {

//                 send_to: 'G-MTHYR484J8',

//                 'Home or Agency':
//                     data_handle,

//                 'Agency name (city)':
//                     agency_name,

//                 currency:
//                     data_currency
//             });

//         }

//     } catch (trackingError) {
//         console.error('Tracking error:', trackingError);
//     }


//     return false;
// }




// ============================================
// SEARCH INPUT CHANGE - Clear lat/long
// ============================================
$(document).on("change", "#search_input", function () {
    if (document.getElementById("latitude_input"))
        document.getElementById("latitude_input").value = "";
    if (document.getElementById("longitude_input"))
        document.getElementById("longitude_input").value = "";
    if (document.getElementById("latitude_view"))
        document.getElementById("latitude_view").innerHTML = "";
    if (document.getElementById("longitude_view"))
        document.getElementById("longitude_view").innerHTML = "";
});

// ============================================
// SHIPPING AND ACCORDION HANDLERS
// ============================================
$(document).on("change", ".shipping-line-item--radio input[type='radio']", function () {
    $(".agent-dropdown").hide();
    if ($(this).data("agent") == true) {
        $(this).parents(".shipping-line-item--radio").find(".agent-dropdown").show();
    }
});

$(document).on("click", ".accordion-section-wrapper-main .custom_accordion-btn", function () {
    $(this).parents(".accordion-section-wrapper-main").find(".accordion-section-content_last").slideToggle();
});